export default __webpack_public_path__ + "static/media/ceramol-acn3-rebalance-mat.5c1b4f39.png";